'use strict';

module.exports = {
  'Pricing Group': 'pricingGroup',
  'Architecture Group': 'architectureGroup',
  Category: 'category',
};
